var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.961,
    height: 27.049,
    viewBox: "0 0 36.961 27.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6284",
    "data-name": "Group 6284",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6144",
    "data-name": "Path 6144",
    d: "M307.761,375.435a18.384,18.384,0,0,1-13.615-5.4,24.414,24.414,0,0,1-5.263-7.531,1.35,1.35,0,0,1-.07-.981,22.594,22.594,0,0,1,9.643-10.926,17.642,17.642,0,0,1,9.683-2.178c6.57.346,11.421,3.651,15.1,8.883a41.166,41.166,0,0,1,2.356,4.132,1.055,1.055,0,0,1,.055.821c-2.43,5.294-6,9.5-11.477,11.837A17.609,17.609,0,0,1,307.761,375.435Zm-9.014-13.573a8.468,8.468,0,1,0,8.532-8.417A8.52,8.52,0,0,0,298.748,361.862Z",
    transform: "translate(-288.748 -348.39)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6145",
    "data-name": "Path 6145",
    d: "M444.623,453.7a5.07,5.07,0,1,1,5.094-5.016A5.083,5.083,0,0,1,444.623,453.7Z",
    transform: "translate(-426.179 -435.108)",
    fill: "#d0d0d0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.19375697305d7ebda33f801eda093522.svg";
export { ForwardRef as ReactComponent };